<script>
const icons = {
  arrow: {
    width: 31,
    height: 31,
    content:
      '<path d="M27.21 17.034H7.726l6.705 6.705a1.25 1.25 0 11-1.768 1.768l-8.839-8.839a1.262 1.262 0 01-.155-.19c-.021-.032-.036-.066-.054-.099-.02-.038-.044-.075-.06-.116-.019-.042-.029-.086-.041-.13-.01-.035-.024-.068-.031-.103a1.248 1.248 0 01-.025-.246v-.003c0-.08.009-.162.025-.241.007-.038.021-.073.032-.11.013-.041.022-.083.039-.123.018-.044.042-.083.065-.124.017-.03.03-.062.05-.091.045-.07.098-.134.156-.192l8.838-8.838a1.25 1.25 0 011.768 1.768l-6.705 6.704h19.482a1.25 1.25 0 010 2.5z"/>',
  },
  close: {
    width: 20,
    height: 20,
    content:
      '<path d="M7.172 14.242L10 11.414L12.828 14.242L14.242 12.828L11.414 10L14.242 7.172L12.828 5.758L10 8.586L7.172 5.758L5.758 7.172L8.586 10L5.758 12.828L7.172 14.242Z"/><path d="M10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20ZM10 2C14.411 2 18 5.589 18 10C18 14.411 14.411 18 10 18C5.589 18 2 14.411 2 10C2 5.589 5.589 2 10 2Z"/>'
  },
  download: {
    width: 24,
    height: 24,
    content: '<path d="M11.984.986A1 1 0 0011 2v11.586l-2.293-2.293a1 1 0 10-1.414 1.414l3.912 3.912a1 1 0 001.588.004 1 1 0 00.004-.006l3.91-3.91a1 1 0 10-1.414-1.414L13 13.586V2A1 1 0 0011.984.986zm-9 15A1 1 0 002 17v3c0 1.645 1.355 3 3 3h14c1.645 0 3-1.355 3-3v-3a1 1 0 10-2 0v3c0 .564-.436 1-1 1H5c-.564 0-1-.436-1-1v-3a1 1 0 00-1.016-1.014z"/>',
  },
  link: {
    width: 20,
    height: 10,
    content: '<path d="M15 0H11V2H15C16.65 2 18 3.35 18 5C18 6.65 16.65 8 15 8H11V10H15C17.76 10 20 7.76 20 5C20 2.24 17.76 0 15 0ZM9 8H5C3.35 8 2 6.65 2 5C2 3.35 3.35 2 5 2H9V0H5C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10H9V8ZM6 4H14V6H6V4Z"/>',
  },
  paginationArrow: {
    width: 10,
    height: 16,
    content: '<path d="M7.92207 16L0.000505447 8L7.92207 0L9.88477 1.98213L3.92589 8L9.88477 14.0179L7.92207 16Z"/>'
  },
  menu: {
    width: 30,
    height: 30,
    content: '<rect x="4" y="14" width="22" height="2"/><rect x="4" y="8" width="22" height="2"/><rect x="4" y="20" width="22" height="2"/>',
  },
  closeMenu: {
    width: 30,
    height: 30,
    content: '<rect x="4" y="14" width="22" height="2" transform="rotate(45 15 15)"/><rect x="4" y="14" width="22" height="2" transform="rotate(-45 15 15)"/>',
  },
  video: {
    width: 120,
    height: 121,
    content:
      '<path d="M47.875 46.0776V74.8276C47.875 76.3276 48.5208 77.4526 49.8125 78.2026C51.1042 78.9526 52.375 78.911 53.625 78.0776L76.25 63.5776C77.4167 62.8276 78 61.786 78 60.4526C78 59.1193 77.4167 58.0776 76.25 57.3276L53.625 42.8276C52.375 41.9943 51.1042 41.9526 49.8125 42.7026C48.5208 43.4526 47.875 44.5776 47.875 46.0776ZM60 110.453C53.1667 110.453 46.7083 109.14 40.625 106.515C34.5417 103.89 29.2292 100.307 24.6875 95.7651C20.1458 91.2235 16.5625 85.911 13.9375 79.8276C11.3125 73.7443 10 67.286 10 60.4526C10 53.6193 11.3125 47.161 13.9375 41.0776C16.5625 34.9943 20.1458 29.6818 24.6875 25.1401C29.2292 20.5985 34.5417 17.0151 40.625 14.3901C46.7083 11.7651 53.1667 10.4526 60 10.4526C66.8333 10.4526 73.2917 11.7651 79.375 14.3901C85.4583 17.0151 90.7708 20.5985 95.3125 25.1401C99.8542 29.6818 103.438 34.9943 106.062 41.0776C108.688 47.161 110 53.6193 110 60.4526C110 67.286 108.688 73.7443 106.062 79.8276C103.438 85.911 99.8542 91.2235 95.3125 95.7651C90.7708 100.307 85.4583 103.89 79.375 106.515C73.2917 109.14 66.8333 110.453 60 110.453ZM60 102.953C71.6667 102.953 81.6667 98.786 90 90.4526C98.3333 82.1193 102.5 72.1193 102.5 60.4526C102.5 48.786 98.3333 38.786 90 30.4526C81.6667 22.1193 71.6667 17.9526 60 17.9526C48.3333 17.9526 38.3333 22.1193 30 30.4526C21.6667 38.786 17.5 48.786 17.5 60.4526C17.5 72.1193 21.6667 82.1193 30 90.4526C38.3333 98.786 48.3333 102.953 60 102.953Z"/>',
  },
  file: {
    width: 48,
    height: 49,
    content:
      '<path d="M17.45 35.9526H30.55C30.9833 35.9526 31.3417 35.811 31.625 35.5276C31.9083 35.2443 32.05 34.886 32.05 34.4526C32.05 34.0193 31.9083 33.661 31.625 33.3776C31.3417 33.0943 30.9833 32.9526 30.55 32.9526H17.45C17.0167 32.9526 16.6583 33.0943 16.375 33.3776C16.0917 33.661 15.95 34.0193 15.95 34.4526C15.95 34.886 16.0917 35.2443 16.375 35.5276C16.6583 35.811 17.0167 35.9526 17.45 35.9526ZM17.45 27.4526H30.55C30.9833 27.4526 31.3417 27.311 31.625 27.0276C31.9083 26.7443 32.05 26.386 32.05 25.9526C32.05 25.5193 31.9083 25.161 31.625 24.8776C31.3417 24.5943 30.9833 24.4526 30.55 24.4526H17.45C17.0167 24.4526 16.6583 24.5943 16.375 24.8776C16.0917 25.161 15.95 25.5193 15.95 25.9526C15.95 26.386 16.0917 26.7443 16.375 27.0276C16.6583 27.311 17.0167 27.4526 17.45 27.4526ZM11 44.4526C10.2 44.4526 9.5 44.1526 8.9 43.5526C8.3 42.9526 8 42.2526 8 41.4526V7.45264C8 6.65264 8.3 5.95264 8.9 5.35264C9.5 4.75264 10.2 4.45264 11 4.45264H27.8C28.2 4.45264 28.5917 4.53597 28.975 4.70264C29.3583 4.8693 29.6833 5.08597 29.95 5.35264L39.1 14.5026C39.3667 14.7693 39.5833 15.0943 39.75 15.4776C39.9167 15.861 40 16.2526 40 16.6526V41.4526C40 42.2526 39.7 42.9526 39.1 43.5526C38.5 44.1526 37.8 44.4526 37 44.4526H11ZM27.55 15.2526V7.45264H11V41.4526H37V16.7526H29.05C28.6167 16.7526 28.2583 16.611 27.975 16.3276C27.6917 16.0443 27.55 15.686 27.55 15.2526ZM11 7.45264V16.7526V7.45264V41.4526V7.45264Z"/>',
  },
};

export default {
  name: "SvgIcon",
  props: {
    icon: String,
  },
  computed: {
    currentIcon() {
      return icons[this.icon] || null;
    },
    width() {
      if (!this.currentIcon) {
        return 0;
      }

      return this.currentIcon.width;
    },
    height() {
      if (!this.currentIcon) {
        return 0;
      }

      return this.currentIcon.height;
    },
    viewBox() {
      if (!this.currentIcon) {
        return "0 0 0 0";
      }

      return "0 0 " + this.currentIcon.width + " " + this.currentIcon.height;
    },
    content() {
      if (!this.currentIcon) {
        return "";
      }

      return this.currentIcon.content;
    },
  },
};
</script>

<template>
  <svg
    v-if="this.currentIcon"
    class="icon"
    xmlns="http://www.w3.org/2000/svg"
    v-bind:width="width"
    v-bind:height="height"
    v-bind:viewBox="viewBox"
    fill="currentColor"
    v-html="content"
  ></svg>
</template>
